import React, { useState } from "react";
import { Trash2, Settings, MoreHorizontal } from "react-feather"; // Import icons
import { handleDeleteService } from "../../services/taps";
import DeleteSourceModal from "../Modals/DeleteSource";
import { CircularProgress, Button, Tooltip } from "@mui/material";
import Dropdown from "../global/Dropdown";

function ConnectorCard({ datasource, onDeleteSuccess }) {
  const sourceAlias =
    datasource && datasource.source_alias ? datasource.source_alias : "";
  const [isLoading, setIsLoading] = useState(false); // Add state to manage loading
  const [isDeleting, setIsDeleting] = useState(false); // Add state to manage loading
  const [showDelete, setShowDelete] = useState(false); // State to manage modal visibility
  const truncatedAlias =
    sourceAlias.length > 10
      ? `${sourceAlias.substring(0, 10)}...`
      : sourceAlias;

  // Function to handle delete action
  const handleDelete = async (e) => {
    setIsDeleting(true);
    e.stopPropagation(); 
    setIsLoading(true);
    const isSuccess = await handleDeleteService(datasource.id, datasource.source_alias);

    if(isSuccess) {
      setShowDelete(false); // Close modal after deletion
      onDeleteSuccess();
    }

    setIsLoading(false);
    setIsDeleting(false);
  };

  const handleCloseModal = (e) => {
    if (e) {
      e.stopPropagation(); // Prevent triggering the card click event
    }
    setShowDelete(false); // Close the modal
  };

  // Function to handle dropdown item click
  const handleDropdownItemClick = (e, action) => {
    e.stopPropagation(); // Prevent triggering the card click event
    if (action === "delete") {
      setShowDelete(true); // Show delete modal
    }
    // Add other actions here if needed
  };

  return (
    <>
      <div
        className="card-taps"
        role="button"
        tabIndex={0}
        aria-pressed="false"
        style={{ cursor: "pointer", position: "relative" }}
      >
        <div
          className="card-taps-body connector-card-taps-body"
          title={
            datasource && datasource.label ? datasource.label : datasource.alias
          }
        >
          <center>
            <div className="connector-image">
              {datasource && datasource.logo ? (
                <img
                  src={datasource.logo}
                  style={{ maxWidth: "100%", maxHeight: "100%" }}
                  loading="lazy"
                  alt=""
                  className="image-contain"
                />
              ) : null}
            </div>
          </center>
          <div className="card-taps-info" style={{ flexGrow: 3 }}>
            <center>
              <div
                className="card-taps-title text-center"
                style={{
                  wordWrap: "break-word",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  fontSize: "10px",
                  lineHeight: "15px",
                  maxWidth: "100px",
                }}
                title={
                  datasource && datasource.label
                    ? datasource.label
                    : datasource.alias
                }
              >
                {datasource && datasource.label
                  ? datasource.label
                  : datasource.alias}
              </div>
            </center>
            <div className="card-taps-metadata">
              {datasource && datasource.tap_group}
            </div>
          </div>
          <div className="card-taps-metadata mt-1">
            {datasource && !datasource.status ? (
              <>
                <Tooltip title={sourceAlias}>
                  <Button
                    variant="outlined"
                    sx={{
                      borderColor: "#27cc97",
                      color: "#27cc97",
                      minWidth: 0,
                      width: "100px"
                    }}
                    size="small"
                  >
                    {truncatedAlias}
                  </Button>
                </Tooltip>
                <div
                  className="icons-wrapper"
                  style={{
                    position: "absolute",
                    bottom: "10px",
                    right: "10px",
                  }}
                >
                  <Dropdown>
                    <Dropdown.Button
                      endIcon={undefined}
                      sx={{
                        color: "#afafc1",
                        fontSize: "14px",
                        lineHeight: "28px",
                        height: "28px"
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <MoreHorizontal size={14} />
                    </Dropdown.Button>
                    <Dropdown.Menu
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      onClick={e => e.stopPropagation()}
                    >
                      <Dropdown.MenuItem 
                        href="#/edit-source"
                        disabled={true}
                        onClick={(e) => handleDropdownItemClick(e, "edit")}
                        sx={{
                          lineHeight: "28px",
                          fontSize: "11px"
                        }}
                      >
                        <Settings size={14} className="me-2" /> Edit connection details
                      </Dropdown.MenuItem>
                      <Dropdown.MenuItem
                        onClick={(e) => handleDropdownItemClick(e, "delete")}
                        sx={{
                          lineHeight: "28px",
                          fontSize: "11px"
                        }}
                      >
                        <Trash2 size={14} className="me-2" /> Delete source
                      </Dropdown.MenuItem>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </>
            ) : (
              <Button
                variant="contained"
                disabled={isLoading}
                sx={{ 
                  fontSize: "8px",
                  bgcolor: datasource && datasource.status === "Live" ? "#4BBF73" : "#3F80EA",
                  border: datasource && datasource.status === "Live" ? "1px solid #4BBF73" : "1px solid #3F80EA",
                  borderRadius: "50rem",
                  minWidth: 0,
                  padding: "0.25rem 0.7rem",

                  "&:hover": {
                    bgcolor: datasource && datasource.status === "Live" ? "#66c988" : "#366dc7"
                  },
                  "&:disabled": {
                    bgcolor: datasource && datasource.status === "Live" ? "#4BBF73" : "#3F80EA",
                    color: "#fff"
                  }
                }}
              >
                {isLoading ? (
                  <CircularProgress size={16} color="#fff" />
                ) : datasource && datasource.status ? (
                  datasource.status.toUpperCase()
                ) : (
                  ""
                )}
              </Button>
            )}
          </div>
        </div>
      </div>

      {/* Modal for delete confirmation */}
      <DeleteSourceModal
        isShown={showDelete}
        onHide={handleCloseModal}
        onAction={handleDelete}
        isDeleting={isDeleting}
        sourceAlias={sourceAlias}
        taps={datasource?.taps}
      />
    </>
  );
}

export default ConnectorCard;
